import { render, staticRenderFns } from "./setRowProperties.vue?vue&type=template&id=771b9acf&scoped=true&"
import script from "./setRowProperties.vue?vue&type=script&lang=js&"
export * from "./setRowProperties.vue?vue&type=script&lang=js&"
import style0 from "./setRowProperties.vue?vue&type=style&index=0&id=771b9acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b9acf",
  null
  
)

export default component.exports